import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ETooltipAlign, ETooltipPlacement, Tooltip, } from 'Shared/components';
import styles from './IndicatorsTag.css';
const IndicatorsTag = ({ tagValue, tooltipContent }) => (_jsx(Tooltip, Object.assign({ placement: ETooltipPlacement.BottomCenter, align: ETooltipAlign.Center, tooltipContent: tooltipContent, className: styles.tooltip }, { children: _jsx("div", Object.assign({ className: styles.tag }, { children: tagValue }), void 0) }), void 0));
export default memo(IndicatorsTag);
